module.exports = __webpack_public_path__ + "img/decline.a276c3e5.svg";